import { render, staticRenderFns } from "./ServiceProviderBankTransfers.vue?vue&type=template&id=5bb58f6a&style=font-family%3AAlmarai&"
import script from "./ServiceProviderBankTransfers.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderBankTransfers.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderBankTransfers.vue?vue&type=style&index=0&id=5bb58f6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports